import { ItemRevision } from './item-revision';
import { ItemStructure } from './item-structure';

export class PartDesignItemStructure extends ItemStructure {
  public constructor(
    itemId: string,
    itemName: string,
    itemType: string,
    revisions: ItemRevision[],
    public tsItem?: ItemStructure,
    public csItem?: ItemStructure,
    public apItem?: ItemStructure
  ) {
    super(itemId, itemName, itemType, revisions);
  }
}
